// S :::: 이미지 불러오기 :::: S

import Board01Image01 from "../assets/images/board/board01/Board01Image01.webp";
import Board01Image02 from "../assets/images/board/board01/Board01Image02.webp";
import Board01Image03 from "../assets/images/board/board01/Board01Image03.webp";

import Board02Image01 from "../assets/images/board/board02/Board02Image01.webp";

import Board03Image01 from "../assets/images/board/board03/Board03Image01.webp";
import Board03Image02 from "../assets/images/board/board03/Board03Image02.webp";

import Board04Image01 from "../assets/images/board/board04/Board04Image01.webp";
import Board04Image02 from "../assets/images/board/board04/Board04Image02.webp";
import Board04Image03 from "../assets/images/board/board04/Board04Image03.webp";
import Board04Image04 from "../assets/images/board/board04/Board04Image04.webp";
import Board04Image05 from "../assets/images/board/board04/Board04Image05.webp";

import Board05Image01 from "../assets/images/board/board05/Board05Image01.webp";
import Board05Image02 from "../assets/images/board/board05/Board05Image02.webp";
import Board05Image03 from "../assets/images/board/board05/Board05Image03.webp";
import Board05Image04 from "../assets/images/board/board05/Board05Image04.webp";
import Board05Image05 from "../assets/images/board/board05/Board05Image05.webp";
import Board05Image06 from "../assets/images/board/board05/Board05Image06.webp";

import Board06Image01 from "../assets/images/board/board06/Board06Image01.webp";
import Board06Image02 from "../assets/images/board/board06/Board06Image02.webp";
import Board06Image03 from "../assets/images/board/board06/Board06Image03.webp";
import Board06Image04 from "../assets/images/board/board06/Board06Image04.webp";
import Board06Image05 from "../assets/images/board/board06/Board06Image05.webp";
import Board06Image06 from "../assets/images/board/board06/Board06Image06.webp";

import Board07Image01 from "../assets/images/board/board07/Board07Image01.webp";
import Board07Image02 from "../assets/images/board/board07/Board07Image02.webp";
import Board07Image03 from "../assets/images/board/board07/Board07Image03.webp";
import Board07Image04 from "../assets/images/board/board07/Board07Image04.webp";
import Board07Image05 from "../assets/images/board/board07/Board07Image05.webp";
import Board07Image06 from "../assets/images/board/board07/Board07Image06.webp";

import Board08Image01 from "../assets/images/board/board08/Board08Image01.webp";
import Board08Image02 from "../assets/images/board/board08/Board08Image02.webp";
import Board08Image03 from "../assets/images/board/board08/Board08Image03.webp";
import Board08Image04 from "../assets/images/board/board08/Board08Image04.webp";
import Board08Image05 from "../assets/images/board/board08/Board08Image05.webp";
import Board08Image06 from "../assets/images/board/board08/Board08Image06.webp";
import Board08Image07 from "../assets/images/board/board08/Board08Image07.webp";

import Board09Image01 from "../assets/images/board/board09/Board09Image01.webp";
import Board09Image02 from "../assets/images/board/board09/Board09Image02.webp";
import Board09Image03 from "../assets/images/board/board09/Board09Image03.webp";
import Board09Image04 from "../assets/images/board/board09/Board09Image04.webp";
import Board09Image05 from "../assets/images/board/board09/Board09Image05.webp";
import Board09Image06 from "../assets/images/board/board09/Board09Image06.webp";
import Board09Image07 from "../assets/images/board/board09/Board09Image07.webp";
import Board09Image08 from "../assets/images/board/board09/Board09Image08.webp";

import Board10Image01 from "../assets/images/board/board10/Board10Image01.webp";
import Board10Image02 from "../assets/images/board/board10/Board10Image02.webp";
import Board10Image03 from "../assets/images/board/board10/Board10Image03.webp";
import Board10Image04 from "../assets/images/board/board10/Board10Image04.webp";
import Board10Image05 from "../assets/images/board/board10/Board10Image05.webp";
import Board10Image06 from "../assets/images/board/board10/Board10Image06.webp";
import Board10Image07 from "../assets/images/board/board10/Board10Image07.webp";

import Board11Image01 from "../assets/images/board/board11/Board11Image01.webp";
import Board11Image02 from "../assets/images/board/board11/Board11Image02.webp";
import Board11Image03 from "../assets/images/board/board11/Board11Image03.webp";
import Board11Image04 from "../assets/images/board/board11/Board11Image04.webp";
import Board11Image05 from "../assets/images/board/board11/Board11Image05.webp";

import Board12Image01 from "../assets/images/board/board12/Board12Image01.webp";
import Board12Image02 from "../assets/images/board/board12/Board12Image02.webp";
import Board12Image03 from "../assets/images/board/board12/Board12Image03.webp";
import Board12Image04 from "../assets/images/board/board12/Board12Image04.webp";

import Board13Image01 from "../assets/images/board/board13/Board13Image01.webp";
import Board13Image02 from "../assets/images/board/board13/Board13Image02.webp";

import Board14Image01 from "../assets/images/board/board14/Board14Image01.webp";
import Board14Image02 from "../assets/images/board/board14/Board14Image02.webp";
import Board14Image03 from "../assets/images/board/board14/Board14Image03.webp";
import Board14Image04 from "../assets/images/board/board14/Board14Image04.webp";
import Board14Image05 from "../assets/images/board/board14/Board14Image05.webp";
import Board14Image06 from "../assets/images/board/board14/Board14Image06.webp";

// E :::: 이미지 불러오기 :::: E

// S ::::: 협회 활동 ::::: S
export const boardLists = [
  {
    id: "14",
    title: "[2026 IPDIA 지도자 대상 작품 세미나]",
    date: "2026-07-21",
    listText: "[2026 IPDIA 지도자 대상 작품 세미나]",
    detailText: `
   [2026 IPDIA 지도자 대상 작품 세미나]

지난 7월 17일 [IPDIA 국제실용댄스지도자협회]에서
2026 IPDIA 작품 세미나가 성공적으로 진행되었습니다

이번 작품 세미나는
IPDIA 전문 댄스 자격증을 취득하신 지도자분들을 대상으로
프라이빗하게 진행되었습니다.
수료 이후에도 소속 지도자분들이
꾸준히 성장하고 현장에서 적용하실 수 있도록,
난이도별 · 레벨별 수업 가이드와 다양한 작품을 아낌없이
제공해 드리는 자리였습니다.

아낌없이 지도해주신 안무가 블레이즈 협회장님,
본부센터의 공식 트레이너 은혜선생님,
서로에게 긍정적인 열정을 나눠주며 함께 해주신
참가자 여러분 덕분에 이번 세미나가 더욱 특별하고
꽉 찬 시간으로 빛날 수 있었습니다.

IPDIA 국제실용댄스지도자협회는
단순한 자격 취득에 그치지 않고,
수료생분들의 지속적인 발전과 전문성 향상을 위해
앞으로도 다양한 교육과 유익한 프로그램으로 늘 함께하겠습니다.

감사합니다.

-
⠀
⠀
📌 자세한 협회 및 자격과정 확인
www.ipdiakorea.com
⠀⠀
⠀⠀
📌 IPDIA 공식 트레이닝 센터 안내
▶서울 본부센터 [넵튠댄스스튜디오]
• 주소 : 서울 동작구 사당로16길 28 3층
• 전화/문자 : 010-2351-8784
• 카카오톡 검색 : 넵튠댄스스튜디오
⠀
▶남양주지부 [리버스댄스하우스]
• 주소 : 경기도 남양주시 경춘로490 1동 B1층 1129호
• 전화/문자 : 010-2751-2342
• 카카오톡 검색 : 리버스댄스하우스

▶대전지부 [투비셔플]
• 주소 : 대전 유성구 은구비남로 41 502호
• 전화/문자 : 010-5828-5559
• 카카오톡 검색 : 투비셔플
⠀⠀
▶경기 광주지부 [버닝댄스스튜디오]
• 주소 : 경기 광주시 고산길 17-2, 2층 201호
• 전화/문자 : 010-8823-4794
• 카카오톡 검색 : 버닝댄스스튜디오
    `,
    thumb: Board14Image01,
    images: [
      Board14Image01,
      Board14Image02,
      Board14Image03,
      Board14Image04,
      Board14Image05,
      Board14Image06,
    ],
  },
  {
    id: "13",
    title: "【셔플댄스 지도자 자격증 2급 3기 수료】",
    date: "2026-06-18",
    listText: "【셔플댄스 지도자 자격증 2급 3기 수료】",
    detailText: `
   【셔플댄스 지도자 자격증 2급 3기 수료】

[IPDIA 국제실용댄스지도자협회] 의
셔플댄스 지도자 자격증 2급 3기 과정이
수료식을 끝으로 성공적으로 마무리 되었습니다🥳

이번 2급 과정은 
셔플댄스의 깊이 있는 이해와 성장의 핵심인 기본기를 
탄탄하게 구축하는 데 집중하였습니다.
지도자 자격 취득뿐만 아니라, 
개개인의 기술적 성장과 전반적인 춤의 이해도를 
한 단계 더 높이는 뜻 깊은 시간으로 구성되었습니다.

교육기간 동안 뜨거운 열정과 꾸준한 노력을 보여주신 
2급 3기 수료생분들께 진심 어린 박수를 보내며,
앞으로 펼쳐나가실 활동을 늘 응원하겠습니다

자격 취득을 진심으로 축하드립니다👏🎉


-
 

📌 자세한 협회 및 자격과정 확인
www.ipdiakorea.com


📌 IPDIA 공식 트레이닝 센터 안내
▶서울 본부센터 [넵튠댄스스튜디오] 
• 주소 : 서울 동작구 사당로16길 28 3층
• 전화/문자 : 010-2351-8784
• 카카오톡 검색 : 넵튠댄스스튜디오

▶대전지부 [투비셔플]
• 주소 : 대전 유성구 은구비남로 41 502호
• 전화/문자 : 010-5828-5559
• 카카오톡 검색 : 투비셔플
⠀
▶경기 광주지부 [버닝댄스스튜디오]
• 주소 : 경기 광주시 고산길 17-2, 2층 201호
• 전화/문자 : 010-8823-4794
• 카카오톡 검색 : 버닝댄스스튜디오
    `,
    thumb: Board13Image01,
    images: [Board13Image01, Board13Image02],
  },
  {
    id: "12",
    title: "[셔플댄스 지도자 2급 3기 자격증 진행과정]",
    date: "2026-06-09",
    listText: "[셔플댄스 지도자 2급 3기 자격증 진행과정]",
    detailText: `
   IPDIA 국제실용댄스지도자협회의
[셔플댄스 지도자 자격과정]이 
현재 서울 본부센터 [넵튠댄스스튜디오] 에서 
체계적인 시스템 아래 진행되고 있습니다. 

본 협회의 댄스 자격 과정은 단순 취미를 넘어,
확실한 실력 향상을 목표로 하는 분들과 
깊이 있는 자기계발을 희망하는 분들을 위한 
고도화된 전문 프로그램입니다

특히 실무 역량을 갖춘 전문 강사를 육성하는 만큼, 
탄탄하고 검증된 트레이닝을 경험하실 수 있습니다 

다양한 세대의 도전이 실현될 수 있도록, 
IPDIA는 언제나 진심을 담은 교육으로 
여러분과 함께하겠습니다.

뜨거운 열정으로 교육을 완주한,
[셔플댄스 지도자 2급 3기] 교육생분들의 수료를 기대하며,

앞으로도 이어지는 IPDIA만의
차별화된 다양한 프로그램에 많은 관심 부탁드립니다.


📌 전문자격증 과정 | 등록 문의
i 서울 본부센터 INFO
• 주소 : 서울 동작구 사당로16길 28 3층
• 전화/문자 : 010-2351-8784, 010-7620-8784
• 카카오톡 검색 : 넵튠댄스스튜디오
• @neptuneseoul

📍IPDIA KOREA 지부 안내
i 대전 지부 INFO
• 주소 : 대전 유성구 은구비남로 41 502호
• 전화/문자 : 010-5828-5559
• 카카오톡 검색 : 투비셔플
• @shuffle_seojung
⠀
i 경기 광주 지부 INFO
• 주소 : 경기 광주시 고산길 17-2, 2층 201호
• 전화/문자 : 010-8823-4794
• 카카오톡 검색 : 버닝댄스스튜디오
• @burningdancestudio_kkeng
    `,
    thumb: Board12Image01,
    images: [Board12Image01, Board12Image02, Board12Image03, Board12Image04],
  },
  {
    id: "11",
    title: "[VLAZE 셔플워크샵 IN 대전 후기]",
    date: "2026-04-23",
    listText: "[VLAZE 셔플워크샵 IN 대전 후기]",
    detailText: `
   IPDIA 국제실용댄스지도자협회
대전지부인 <투비셔플> 에서
VLAZE 협회장님의 워크샵이
뜨거운 열기 속에 성공적으로 마무리되었습니다.

열정 가득히 참여해 주시고,
따뜻하게 환영해주신 대전 여러분들께 감사 인사 드립니다,
다음 워크샵에서도 뵙길 기대하겠습니다


📌대전지부 [투비셔플] 안내

대전지부 <투비셔플>은 국제실용댄스지도자협회 소속 센터로, 서울 본부인 넵튠과의 교류를 통해
대전에서도 높은 수업 퀄리티와 트렌디한 셔플댄스를
만나보실 수 있습니다

앞으로도 IPDIA는
독보적인 프로그램, 완성도 높은 교육환경으로 보답하겠습니다.
감사합니다

-

i 서울 본부센터 INFO
▪️주소 : 서울 동작구 사당로16길 28 3층
▪️전화/문자 : 010-2351-8784, 010-7620-8784
▪️카카오톡 검색 : 넵튠댄스스튜디오

i 대전지부 INFO
▪️주소 : 대전 유성구 은구비남로 41 502호
▪️전화/문자 : 010-5828-5559
▪️카카오톡 검색 : 투비셔플
    `,
    thumb: Board11Image05,
    images: [
      Board11Image01,
      Board11Image02,
      Board11Image03,
      Board11Image04,
      Board11Image05,
    ],
  },

  {
    id: "10",
    title: "[ 셔플댄스 지도자 자격증 1급 1기 수료 ]",
    date: "2026-03-28",
    listText: "[ 셔플댄스 지도자 자격증 1급 1기 수료 ]",
    detailText: `
   [IPDIA 국제실용댄스지도자협회]의
셔플댄스 지도자 자격증 1급 1기가
수료식을 끝으로 성공적으로 마무리 되었습니다!

1급 과정에 걸맞은 전문 소양을 갖추기 위해
달려오신 수료생 분들의 완주를 진심으로 축하드립니다.

📚IPDIA의 전문 자격 과정은
단순한 증서 발급이 아닌,
현장에서 경쟁력을 가질 수 있는 실무 중심의 커리큘럼을 지향합니다.

커리어가 뛰어난 전문 댄서 강사진들의 코칭을 통해
역량 강화를 제대로 경험하실 수 있는 프로그램입니다.

🎓이번 과정을 통해 쌓은 전문 지식과 경험이
여러분의 활동에 견고한 기반이 되길 바라며,

앞으로도 국제실용댄스지도자협회 소속으로
건강하고 수준 높은 댄스 문화를 만들어갈
여러분의 행보를 응원하겠습니다.

📌 전문자격증 과정 | 등록 문의
서울 본부센터 [넵튠댄스스튜디오]
▬ 전화/문자
010-2351-8784
010-7620-8784
💬카카오톡 문의
http://pf.kakao.com/_xdxcJZn


📍 IPDIA KOREA 지부 안내
▶︎ 대전 지부 | 투비셔플
📞 010-5828-5559
💬 카카오톡 연결
http://pf.kakao.com/_SxeDnn


▶︎ 경기 광주 지부 | 버닝댄스스튜디오
📞 010-8823-4794
💬 카카오톡 연결
https://pf.kakao.com/_bxhDIX
    `,
    thumb: Board10Image01,
    images: [
      Board10Image02,
      Board10Image03,
      Board10Image04,
      Board10Image05,
      Board10Image06,
      Board10Image07,
    ],
  },
  {
    id: "9",
    title: "[셔플댄스 지도자 1급 1기 자격증 교육과정]",
    date: "2026-03-07",
    listText: "[셔플댄스 지도자 1급 1기 자격증 교육과정]",
    detailText: `
   IPDIA 국제실용댄스지도자협회의
[셔플댄스 지도자 1급] 1기 자격 과정이
서울 본부센터 <넵튠댄스스튜디오>에서
전문적인 교육 시스템을 기반으로 진행되고 있습니다.
⠀
본 자격 과정은 단순한 이론 나열이 아닌,
셔플, 풋워크 전반을 아우르는 전문적인 역량강화를 목표로 구성되어 있으며,
⠀
✔ 체계적으로 설계된 깊은 주제의 커리큘럼
✔ 지도자로서 반드시 갖추어야 할 필수 교육
✔ 풍부한 현장 경험을 갖춘 전문 강사진
✔ 실제 교육 현장에서 활용되는 실무 중심 트레이닝
⠀
을 통해 지도자로서의 전문성과 실질적인 역량 강화를 
매우 체감하실 수 있는 시스템입니다.
⠀
특히,
실력과 전문성을 겸비한 다 연령의 지도자 배출을 목표로 하여
다양한 연령대의 도전을 응원하고 있습니다. 
⠀
현재 진행 중인 
[셔플댄스 지도자 1급] 1기 과정 교육생들의 수료를 기대하며,
앞으로도 IPDIA에서 진행되는 다양한 전문 교육 과정에
많은 관심과 참여 부탁드립니다.
⠀
⠀
📌 전문 자격과정 등록 및 문의
⠀
▶︎서울 본부센터 | 넵튠댄스스튜디오
📞 전화 / 문자
010-2351-8784
010-7620-8784
💬카카오톡 문의
http://pf.kakao.com/_xdxcJZn

⠀⠀
📍 IPDIA KOREA 지부 안내
⠀
▶︎  대전 지부 | 투비셔플
📞 010-5828-5559
💬 카카오톡 연결
http://pf.kakao.com/_SxeDnn
⠀
⠀
▶︎ 경기 광주 지부  |  버닝댄스스튜디오
📞 010-8823-4794
💬 카카오톡 연결
https://pf.kakao.com/_bxhDIX
    `,
    thumb: Board09Image01,
    images: [
      Board09Image01,
      Board09Image02,
      Board09Image03,
      Board09Image04,
      Board09Image05,
      Board09Image06,
      Board09Image07,
      Board09Image08,
    ],
  },
  {
    id: "8",
    title: "【2025 DDD FESTIVAL | 넵튠댄스스튜디오 공연 비하인드】",
    date: "2025-09-28",
    listText:
      "PDIA 서울본부센터인 넵튠댄스스튜디오가 2025년 9월 28일 동작댄싱데이 페스티벌(DDD) 공연 무대에 오른 현장을 공개합니다.",
    detailText: `
   IPDIA 서울본부센터인 넵튠댄스스튜디오가
2025년 9월 28일 
동작댄싱데이 페스티벌(DDD)
공연 무대에 오른 현장을 공개합니다.

이번 공연은 특별히
서울본부센터의 강사진과 수강생분들이 함께한 무대로, 선생님들과 지도자 자격증 취득자들을 중심으로 구성하여 진행되었습니다. 

앞으로 IPDIAKOREA와 넵튠은
연령과 상관없이 댄스로 다양한 기회와 많은 경험을 할 수 있는 기회의 장이 되도록 최선을 다하겠습니다.


📌 전문자격증 과정 | 등록 문의
서울 본부센터 [넵튠댄스스튜디오]

▬ 전화/문자
010-2351-8784
010-7620-8784

▬ 카카오톡 문의
http://pf.kakao.com/_xdxcJZn

📍 IPDIA KOREA 지부 안내

- 서울 본부센터 [넵튠댄스스튜디오]
- 카카오톡 연결
http://pf.kakao.com/_xdxcJZn

- 대전지부 [TOBE SHUFFLE]
- 카카오톡 연결
http://pf.kakao.com/_SxeDnn
    `,
    thumb: Board08Image01,
    images: [
      Board08Image01,
      Board08Image02,
      Board08Image03,
      Board08Image04,
      Board08Image05,
      Board08Image06,
      Board08Image07,
    ],
  },
  {
    id: "7",
    title: "【IPDIA 전문자격증 취득자 대상 역량강화 워크샵 진행】",
    date: "2025-08-03",
    listText:
      "국제실용댄스지도자협회(IPDIA KOREA) [셔플댄스 지도자 전문자격증 취득자 대상]",
    detailText: `
   국제실용댄스지도자협회(IPDIA KOREA)
[셔플댄스 지도자 전문자격증 취득자 대상]
역량강화 워크샵 현장을 공개합니다.


이번 워크샵은 전문 자격증 취득자를 대상으로
심화된 주제와 전문 강사진의 트레이닝으로
구성된 교육 워크샵을 진행했는데요.

참가자 간의 지식 교류 및 네트워킹을 통해
보다 깊이 있는 인사이트와 실질적인 전문성을
쌓을 수 있는 시간을 가졌습니다.

앞으로 IPDIAKOREA 국제실용댄스지도자협회는
취득하신 분들만을 위한 혜택과 같은 더할 나위 없는
실력 향상 기화와 많은 인사이트를 제공드릴 것을 약속합니다.

지도자로서의 활동과 여러분들의 도전을 응원 드립니다.
감사합니다.

🔊 [셔플댄스 지도자 자격과정]은
시즌에 따라 정원제로 진행됩니다.
자세한 자격요건 및 상담은 아래를 참고해주세요

📌 전문자격증 과정 | 등록 문의
서울 본부센터 [넵튠댄스스튜디오]

▬ 전화/문자
010-2351-8784
010-7620-8784

▬ 카카오톡 문의
http://pf.kakao.com/_xdxcJZn

📍 IPDIA KOREA 지부 안내

- 서울 본부센터 [넵튠댄스스튜디오]
- 카카오톡 연결
http://pf.kakao.com/_xdxcJZn

- 대전지부 [TOBE SHUFFLE]
- 카카오톡 연결
http://pf.kakao.com/_SxeDnn
    `,
    thumb: Board07Image01,
    images: [
      Board07Image01,
      Board07Image02,
      Board07Image03,
      Board07Image04,
      Board07Image05,
      Board07Image06,
    ],
  },
  {
    id: "6",
    title: "【셔플댄스 지도자 자격과정 2급 2기 | BEHIND-THE-SCENES】",
    date: "2025-06-26",
    listText:
      "국제실용댄스지도자협회(IPDIA KOREA) [셔플댄스 지도자 자격과정 2급 2기] 교육 과정의 마지막 비디오 촬영 현장을 공개합니다.",
    detailText: `
   국제실용댄스지도자협회(IPDIA KOREA)
[셔플댄스 지도자 자격과정 2급 2기] 교육 과정의
마지막 비디오 촬영 현장을 공개합니다.

전문가의 디렉팅과 프로듀싱이 결합된 비디오 작업으로 진행되었으며,
이를 통해 교육생 분들은 실전 경험과 작품 제작 과정을
심도 있게 접하며 실무 역량을 강화하는 시간을 가졌습니다.

국제실용댄스지도자협회의 소속이 되신 것을 환영하며,
앞으로의 활동과 여러분들의 도전을 응원 드리겠습니다.

🔊 [셔플댄스 지도자 자격과정]은
시즌에 따라 정원제로 진행되며
이번 2025 하반기는 1급이 예정되어 있습니다.
자세한 자격요건 및 상담은 아래를 참고해주세요

📌 전문자격증 과정 | 등록 문의
서울 본부센터 [넵튠댄스스튜디오]
▬ 전화/문자
010-2351-8784
010-7620-8784

▬ 카카오톡 문의
http://pf.kakao.com/_xdxcJZn

📍 IPDIA KOREA 지부 안내

- 서울 본부센터 [넵튠댄스스튜디오]
- 카카오톡 연결
http://pf.kakao.com/_xdxcJZn
- 대전지부 [TOBE SHUFFLE]
- 카카오톡 연결
http://pf.kakao.com/_SxeDnn
    `,
    thumb: Board06Image01,
    images: [
      Board06Image01,
      Board06Image02,
      Board06Image03,
      Board06Image04,
      Board06Image05,
      Board06Image06,
    ],
  },
  {
    id: "5",
    title: "[ 셔플댄스 지도자 자격증 2급 2기 수료식 ]",
    date: "2025-06-09",
    listText:
      "[IPDIA KOREA 국제실용댄스지도자협회] 의 셔플댄스 지도자 자격증 2급 2기가 수료식을 끝으로 성공적으로 마무리 되었습니다!",
    detailText: `
   [IPDIA KOREA 국제실용댄스지도자협회] 의
셔플댄스 지도자 자격증 2급 2기가 
수료식을 끝으로 성공적으로 마무리 되었습니다!

수료 및 자격증 취득을 진심으로 축하드립니다.
수료생 여러분의 열정과 노력이 모여
또 하나의 여정을 완주하게 되었습니다.

IPDIA의 전문 자격증 과정을 통해 
확실한 역량강화와 다양한 실전형 경험을 얻어가셨길 바라며
새로운 도전과 앞으로의 활동을 항상 응원하겠습니다!

📌 전문자격증 과정 | 등록 문의
서울 본부센터 [넵튠댄스스튜디오]
▬ 전화/문자
010-2351-8784
010-7620-8784

▬ 카카오톡 문의
http://pf.kakao.com/_xdxcJZn

📍 IPDIA KOREA 지부 안내

• 서울 본부센터 [넵튠댄스스튜디오]
- 카카오톡 연결
http://pf.kakao.com/_xdxcJZn

• 대전지부 [TOBE SHUFFLE]
- 카카오톡 연결
http://pf.kakao.com/_SxeDnn
    `,
    thumb: Board05Image01,
    images: [
      Board05Image01,
      Board05Image02,
      Board05Image03,
      Board05Image04,
      Board05Image05,
      Board05Image06,
    ],
  },
  {
    id: "4",
    title: "🏛️ [셔플댄스 지도자 2급 2기 자격증 교육과정]",
    date: "2025-05-21",
    listText:
      "현재 [셔플댄스 지도자 2급 2기 자격과정]이 서울 본부센터 ”넵튠댄스 스튜디오“에서 체계적으로 진행되고 있습니다.",
    detailText: `
    현재 [셔플댄스 지도자 2급 2기 자격과정]이
서울 본부센터 ”넵튠댄스스튜디오“에서 체계적으로 진행되고 있습니다.

🖋️ 본 과정은 셔플댄스 지도자 양성을 목표로
* 실기와 필수이론이 균형 있게 구성된 커리큘럼
* 검증된 강사진
* 실전 중심의 교육 시스템을 통해
확실한 역량강화를 경험하실 수 있습니다.

IPDIA KOREA는
단순한 기술 습득 이상의
전문소양과 실무 능력을 갖춘 프로 양성을 추구하며
지도자로서의 역량을 갖춘 수료생 배출에 최선을 다하고 있습니다.

🧑‍🏫 [셔플댄스 지도자 2급 2기 자격 과정]이
성공적으로 마무리 되는 동안
앞으로도 많은 관심과 응원 부탁드립니다.
IPDIA KOREA 본부와 지부에서 다양한 전문수업을
만나보실 수 있습니다.


📌 전문자격증 과정 | 등록 문의
서울 본부센터 [넵튠댄스스튜디오]
▬ 전화/문자
010-2351-8784
010-7620-8784

▬ 카카오톡 문의
http://pf.kakao.com/_xdxcJZn

📍 IPDIA KOREA 지부 안내

• 서울 본부센터 [넵튠댄스스튜디오]
 - 카카오톡 연결
 http://pf.kakao.com/_xdxcJZn

• 대전지부 [TOBE SHUFFLE]
 - 카카오톡 연결
 http://pf.kakao.com/_SxeDnn
    `,
    thumb: Board04Image01,
    images: [
      Board04Image01,
      Board04Image02,
      Board04Image03,
      Board04Image04,
      Board04Image05,
    ],
  },
  {
    id: "3",
    title: "[ 셔플댄스 지도자 자격증 1기 수료식 ]",
    date: "2025-03-03",
    listText:
      "IPDIA KOREA 국제실용댄스지도자협회의 셔플댄스 지도자 자격증 2급 1기 교육과정이 그동안의 노력과 열정의 결실인 수료식을 끝으로 성공적으로 마무리되었습니다.",
    detailText: `
    [ 셔플댄스 지도자 자격증 1기 수료식 ]

IPDIA KOREA 국제실용댄스지도자협회의
셔플댄스 지도자 자격증 2급 1기 교육과정이
그동안의 노력과 열정의 결실인 수료식을 끝으로
성공적으로 마무리되었습니다.

PDIA KOREA 국제실용댄스지도자협회는
앞으로도 체계적인 교육과 전문적인 커리큘럼을 통해
더 많은 지도자들이 성장할 수 있도록 양성하는
교육기관으로서의 역할을 지속해 나가겠습니다.

수료생 여러분의 앞으로의 활동을 응원하며,
진심으로 축하드립니다.
    `,
    thumb: Board03Image01,
    images: [Board03Image01, Board03Image02],
  },
  {
    id: "2",
    title:
      "[SHUFFLE DANCE INSTRUCTOR CERTIFICATE COURSE] Powered by IPDIA KOREA",
    date: "2025-03-02",
    listText:
      "국제실용댄스지도자협회(IPDIA KOREA)의 [셔플댄스 지도자 2급 자격과정] 1기가 성공적으로 마무리되었습니다. 📍이번 과정의 최종 단계는 전문가의 디렉팅과 프로듀싱이",
    detailText: `
     [SHUFFLE DANCE INSTRUCTOR CERTIFICATE COURSE]
Powered by IPDIA KOREA

📜국제실용댄스지도자협회(IPDIA KOREA)의
[셔플댄스 지도자 2급 자격과정] 1기가 성공적으로 마무리되었습니다

IPDIA KOREA 국제실용댄스지도자 협회만의 
[셔플댄스 지도자 자격증 2급] 교육과정은
댄스 업계 전문가인 협회장이 직접 설계하여
체계적이고 실무 중심인 교육 시스템으로
전문인재 양성 및 실력향상을 위한
명확한 비전을 제시합니다.

체계적인 시스템, 그리고 신뢰할 수 있는
'댄스 업계' 전문 강사진을 통해,
댄스 지도자, 댄스 전문레벨로 도달할 수 있는
발판을 경험하게 될 것입니다.

📍이번 [셔플댄스 지도자 2급 자격과정] 1기의 최종 단계는
전문가의 디렉팅과 프로듀싱이 결합된 비디오 촬영으로 진행되었으며,
이를 통해 교육생 분들은 실전 경험과 작품 제작 과정을
심도 있게 접하며 실무 역량을 강화할 수 있었습니다.

IPDIA KOREA는 1기 수료생들의 앞으로의 활동과 강의를 응원하며,
협회의 전문성과 체계 속에서 수료생들이 한 단계 더 도약할 수 있도록
이끌어가는 확고한 기반이 되어드리겠습니다.

그동안 열심히 달려오신 1기 수료생분들,
국제실용댄스지도자협회의 새로운 일원이 되신 것을 진심으로 축하드리고 환영합니다.
    `,
    thumb: Board02Image01,
    images: [Board02Image01],
  },
  {
    id: "1",
    title: "🌏 EK x NEPTUNE Collaboration KPOP Challenge Program",
    date: "2025-03-01",
    listText:
      "Global KPOP Experience Program Successfully Concluded! 국제실용댄스지도자협회 (IPDIA Korea)의 본부센터인 @neptuneseoul 넵튠과 Essential Korean @essential.korean EK가 콜라보하여",
    detailText: `
   🌏 EK x NEPTUNE Collaboration KPOP Challenge Program

Global KPOP Experience Program Successfully Concluded!

[EK x NEPTUNE KPOP 프로그램]은
IPDIA KOREA 본부센터인 Neptune 넵튠 댄스 스튜디오와 
한국어 교류를 주도하는 Essential Korean와의
협력으로 진행되었는데요!

이 프로그램은 단순히 춤을 배우는 것을 넘어,
KPOP이라는 매개체를 통해
전 세계의 다양한 문화적 배경을 가진 참가자들이
하나로 연결되는 뜻 깊은 자리였습니다.

Program Features
✔️ 다양한 연령대와 문화적 배경의 참가자들이 함께한 K-컬처 체험
✔️ 언어와 춤이 어우러지는 교류의 시간
✔️ 한국 문화에 대한 열정을 나누는 소통의 장

이번 프로젝트가 전 세계 사람들에게
KPOP의 매력을 알리고,
춤으로 문화를 연결하는데 기여했기를 바라며,

앞으로도 IPDIA Korea와 Essential Korean은
글로벌 프로그램을 통해 전 세계와 소통하고
문화를 연결하는 여정을 이어가겠습니다.

앞으로도 춤을 통해 전 세계와 소통하고 문화를 연결하는 여정을
국제실용댄스지도자협회가 주도하여 계속 이어가겠습니다.
    `,
    thumb: Board01Image01,
    images: [Board01Image01, Board01Image02, Board01Image03],
  },
];
// E ::::: 협회 활동 ::::: E
